import { Routes, Route, Navigate } from "react-router-dom";
import { MainLayout } from "../layout";
import DocumentTabsPage from "../pages/document-tabs/DocumentTabsPage";
import CheckInPage from "../pages/check-in/CheckInPage";
import CheckInFormPage from "../pages/check-in-new/CheckInFormPage";
import CheckInNewBulkPage from "../pages/check-in-new-bulk/CheckInNewBulkPage";
import CheckInNewRevisionPage from "../pages/check-in-new-revision/CheckInNewRevisionPage";
import WorkingDocumentCheckInPage from "../pages/working-document-check-in/WorkingDocumentCheckInPage";
import PreviewPage from "../pages/preview/PreviewPage";
import TabConfig from "../components/TabConfig";
import { APP_ROUTES, getDefaultRoute } from "./routeConfig";

/**
 * Routes under MainLayout get sidebar + main content; outlet shows the selected tab page.
 * /config is the Teams tab configuration page (add-tab dialog); must render only TabConfig.
 * Preview page is outside MainLayout so it renders full page without sidebar.
 */
export default function AppRoutes() {
  const defaultRoute = getDefaultRoute();
  return (
    <Routes>
      {/* Teams "Add tab" dialog: show only config UI so tab content loads in the tab, not in the popup */}
      <Route path="/config" element={<TabConfig />} />

      <Route path="/" element={<MainLayout />}>
        <Route index element={<Navigate to={defaultRoute} replace />} />
        <Route path={APP_ROUTES.workingDocuments.replace("/", "")} element={<DocumentTabsPage />} />
        <Route path={APP_ROUTES.allDocuments.replace("/", "")} element={<DocumentTabsPage />} />
        <Route path={APP_ROUTES.templates.replace("/", "")} element={<DocumentTabsPage />} />
        <Route path={APP_ROUTES.checkInNew.replace("/", "")} element={<DocumentTabsPage />} />
        <Route path={APP_ROUTES.checkIn.replace("/", "")} element={<CheckInPage />} />
        <Route path="check-in-new-list" element={<Navigate to={APP_ROUTES.checkInNew} replace />} />
        <Route path="check-in-new/form" element={<CheckInFormPage />} />
        <Route path="check-in-new/bulk-check-in" element={<CheckInNewBulkPage />} />
        <Route path={APP_ROUTES.checkInNewRevision.replace("/", "")} element={<CheckInNewRevisionPage />} />
        <Route
          path={APP_ROUTES.workingDocumentCheckIn.replace(/^\//, "")}
          element={<WorkingDocumentCheckInPage />}
        />
      </Route>

      <Route path="/OpenDocIfsPreview" element={<PreviewPage />} />

      <Route path="*" element={<Navigate to={defaultRoute} replace />} />
    </Routes>
  );
}
